import { useQuery, QueryOptions } from "@tanstack/react-query";
import { API } from "../constants/constants";

export const useDropdownTable = (options: QueryOptions ) => useQuery({
    queryFn: async () => (await API.get("dropdown-table")).data,
    queryKey: ["dropdown-table"],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
})